import React from 'react';
import { LayoutDashboardIcon, GraduationCapIcon, WalletIcon, HomeIcon, ClipboardListIcon, SettingsIcon, ChevronLeftIcon, ChevronRightIcon, CloudIcon } from 'lucide-react';
interface SidebarProps {
  currentPage: string;
  setCurrentPage: (page: string) => void;
  isOpen: boolean;
  toggleSidebar: () => void;
}
export const Sidebar: React.FC<SidebarProps> = ({
  currentPage,
  setCurrentPage,
  isOpen,
  toggleSidebar
}) => {
  const menuItems = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: <LayoutDashboardIcon size={20} data-id="element-35" />
  }, {
    id: 'admissions',
    label: 'Admissions',
    icon: <GraduationCapIcon size={20} data-id="element-36" />
  }, {
    id: 'fees',
    label: 'Fee Management',
    icon: <WalletIcon size={20} data-id="element-37" />
  }, {
    id: 'hostel',
    label: 'Hostel Management',
    icon: <HomeIcon size={20} data-id="element-38" />
  }, {
    id: 'exams',
    label: 'Examinations',
    icon: <ClipboardListIcon size={20} data-id="element-39" />
  }, {
    id: 'cloud-erp',
    label: 'Cloud ERP Guide',
    icon: <CloudIcon size={20} data-id="element-40" />
  }, {
    id: 'settings',
    label: 'Settings',
    icon: <SettingsIcon size={20} data-id="element-41" />
  }];
  return <div className={`${isOpen ? 'w-64' : 'w-20'} bg-gradient-to-b from-indigo-800 to-indigo-900 text-white transition-all duration-300 flex flex-col relative`} data-id="element-42">
      <div className="p-5 flex items-center justify-between border-b border-indigo-700/50" data-id="element-43">
        <div className={`flex items-center space-x-2 ${!isOpen && 'hidden'}`} data-id="element-44">
          <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center" data-id="element-45">
            <span className="text-indigo-800 font-bold text-xl" data-id="element-46">C</span>
          </div>
          <h1 className="font-bold text-xl" data-id="element-47">College ERP</h1>
        </div>
        <button onClick={toggleSidebar} className="p-1.5 rounded-full hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-white/20" data-id="element-48">
          {isOpen ? <ChevronLeftIcon size={18} data-id="element-49" /> : <ChevronRightIcon size={18} data-id="element-50" />}
        </button>
      </div>
      <nav className="flex-1 py-4" data-id="element-51">
        <ul className="space-y-1 px-2" data-id="element-52">
          {menuItems.map(item => <li key={item.id} data-id="element-53">
              <button className={`w-full flex items-center px-3 py-3 rounded-lg ${currentPage === item.id ? 'bg-indigo-700/50 text-white font-medium' : 'text-indigo-100 hover:bg-indigo-700/30'} transition-colors duration-200`} onClick={() => setCurrentPage(item.id)} data-id="element-54">
                <span className="inline-flex items-center justify-center" data-id="element-55">
                  {item.icon}
                </span>
                <span className={`ml-3 ${!isOpen && 'hidden'}`} data-id="element-56">
                  {item.label}
                </span>
              </button>
            </li>)}
        </ul>
      </nav>
      <div className={`p-4 border-t border-indigo-700/50 ${!isOpen && 'hidden'}`} data-id="element-57">
        <div className="flex items-center space-x-3 bg-indigo-700/30 p-3 rounded-lg" data-id="element-58">
          <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center" data-id="element-59">
            <span className="font-semibold text-indigo-800" data-id="element-60">AD</span>
          </div>
          <div data-id="element-61">
            <p className="text-sm font-medium" data-id="element-62">Admin User</p>
            <p className="text-xs text-indigo-200" data-id="element-63">System Administrator</p>
          </div>
        </div>
      </div>
    </div>;
};